import { Component } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { ToastService } from '@teorema/patron';
import { LicenseSessionLockService } from 'src/app/services/license-session-lock.service';
import { WebLicenseCustomerService } from 'src/app/shared/services';

/** Chamado 0000577675 — tela bloqueada sem logout; modal estático como o aceite da LGPD. */
@Component({
  selector: 'app-license-session-lock',
  templateUrl: './license-session-lock.component.html',
  standalone: false,
})
export class LicenseSessionLockComponent {
  takingOver = false;

  constructor(
    public lockService: LicenseSessionLockService,
    private licenseService: WebLicenseCustomerService,
    private authService: AuthService,
    private toastService: ToastService
  ) {}

  get systemLabel(): string {
    const name = this.lockService.lock()?.vendor_system_name;
    return name ? `de ${name} ` : '';
  }

  async useHere() {
    this.takingOver = true;

    try {
      await this.licenseService.takeOver();
      this.lockService.unlock();
      this.toastService.show({ color: 'success', message: 'Licença em uso neste dispositivo' });
    } catch (error: any) {
      this.toastService.show({
        color: 'error',
        message: error?.error?.message ?? 'Não foi possível trazer a licença para este dispositivo',
      });
    } finally {
      this.takingOver = false;
    }
  }

  async logout() {
    this.lockService.unlock();
    await this.authService.logout();
  }
}
